import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/car-service-home";
import About from "./components/car-service-about";
import Footer from "./components/car-service-footer";
import Brand from "./components/car-service-brands";
import Services from "./components/car-service";
import PeriodicMaintenanceService from "./services/periodic-maintanance-services";
import EngineOilService from "./services/engine-oil-service";
import GeneralCheckupService from "./services/general-checkup-service";
import BatteryService from "./services/battery-and-services";
import TyreService from "./services/tyre-services";
import DentingPainting from "./services/denting-painting";
import BumperRepair from "./services/bumper-repair";
import AccidentalRepair from "./services/accidental-repair";
import ScratchRemoval from "./services/scratch-removal";
import PanelReplacement from "./services/panel-replacement";
import CeramicCoating from "./services/ceramic-coating";
import RubbingPolishing from "./services/rubbing-polishing";
import Waxing from "./services/waxing";
import PaintEnhancement from "./services/PaintEnhancement";
import WindshieldCoating from "./services/WindshieldCoating";
import DeepInteriorCleaning from "./services/deepInterior-cleaning";
import ExteriorCleaning from "./services/exterior-cleaning";
import EngineBayCleaning from "./services/EngineBayCleaning";
import DashboardPolishing from "./services/DashboardPolishing";
import EngineRepair from "./services/EngineRepair";
import BrakeRepair from "./services/BrakeRepair";
import SuspensionRepair from "./services/SuspensionRepair";
import ContactUs from "./components/car-service-contact";
import Feedback from "./components/car-service-feedback";
import FAQ from "./components/FAQ";
import Navbar from "./components/car-service-navbar";
import CarServiceBlog from "./components/car-service-blog";
import CarStartNahiHoRahi from "./blog/carstartnahihorahi";
import CarACThandiHawaNahiDeRaha from "./blog/CarACThandiHawaNahiDeRaha";
import CarAcRepair from "./services/car-ac-repair";
import TransmissionService from "./services/transmission";
import CarMileageProblem from "./blog/CarMileageProblem";
function App() {
  return (
    <Router>
      <>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route
            path="/services/periodic-maintenance"
            element={<PeriodicMaintenanceService />}/>
          <Route
            path="/services/engine-oil-filter-change"
            element={<EngineOilService />}/>
          <Route
            path="/services/general-checkup"
            element={<GeneralCheckupService />}/>
          <Route
            path="/services/battery"
            element={<BatteryService />}/>
          <Route
            path="/services/tyre"
            element={<TyreService />}/>
            <Route path="/blog/car-mileage-problem" element={<CarMileageProblem />} />
          <Route
            path="/services/denting-painting"
            element={<DentingPainting />}/>
          <Route
            path="/services/car-ac-repair"
            element={<CarAcRepair />}/>
          <Route
            path="/services/bumper-repair"
            element={<BumperRepair />}/>
          <Route
            path="/services/accidental-repair"
            element={<AccidentalRepair />}/>
          <Route
            path="/services/scratch-removal"
            element={<ScratchRemoval />}/>
          <Route
            path="/services/panel-replacement"
            element={<PanelReplacement />}/>
          <Route
            path="/services/ceramic-coating"
            element={<CeramicCoating />}/>
          <Route
            path="/services/rubbing-polishing"
            element={<RubbingPolishing />}/>
          <Route
            path="/services/waxing"
            element={<Waxing />}/>
          <Route
            path="/services/paint-enhancement"
            element={<PaintEnhancement />}/>
          <Route
            path="/services/windshield-coating"
            element={<WindshieldCoating />}/>
          <Route
            path="/services/interior-cleaning"
            element={<DeepInteriorCleaning />}/>
            <Route
            path="/services/transmission-service"
            element={<TransmissionService />}/>
          <Route
            path="/services/exterior-cleaning"
            element={<ExteriorCleaning />}/>
          <Route
            path="/services/engine-cleaning"
            element={<EngineBayCleaning />}/>
          <Route
            path="/services/dashboard-polish"
            element={<DashboardPolishing />}/>
          <Route
            path="/services/engine-repair"
            element={<EngineRepair />}/>
          <Route
            path="/services/brake-repair"
            element={<BrakeRepair />}/>
          <Route
            path="/services/suspension"
            element={<SuspensionRepair />}/>  
          <Route path="/blog/carstartnahihorahi" element={<CarStartNahiHoRahi />} />
          <Route path="/blog/CarACThandiHawaNahiDeRaha" element={<CarACThandiHawaNahiDeRaha />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<CarServiceBlog />} />
        </Routes>
        <Brand />
        <Footer />
      </>
    </Router>
  );
}

export default App;
